module.exports = __webpack_public_path__ + "img/grid-view.16cc8e2a.svg";